import * as moment from 'moment';

export function getDatePickerLabelByDates(start: number | moment.Moment | Date, end: number | moment.Moment | Date) {
    const startDate = moment(start);
    const endDate = moment(end);

    const isSameDay = startDate.date() === endDate.date();
    const isSameMonth = startDate.month() === endDate.month();
    const isSameYear = startDate.year() === endDate.year();
    const isSameDate = isSameDay && isSameMonth && isSameYear;
    const showYears = startDate.year() !== moment().year() || endDate.year() !== moment().year();

    let startDateFormat = 'MMM D';
    let endDateFormat = 'D';

    if (isSameDate) {
        if (showYears) {
            startDateFormat += ' YYYY';
        }
        return startDate.format(startDateFormat);
    }

    if (isSameMonth && !showYears) {
        return `${startDate.format(startDateFormat)} - ${endDate.format(endDateFormat)}`;
    }

    if (isSameMonth && isSameYear && showYears) {
        endDateFormat += ' YYYY';
        return `${startDate.format(startDateFormat)} - ${endDate.format(endDateFormat)}`;
    }

    endDateFormat = 'MMM D';

    if (showYears) {
        startDateFormat = 'MMM D YYYY';
        endDateFormat += ' YYYY';
    }

    return `${startDate.format(startDateFormat)} - ${endDate.format(endDateFormat)}`;
}